<template>
  <div class="section-header-wrap" :class="{ 'h5-section-header': isH5 }">
    <div class="mb-2 md:mb-10">
      <div class="flex justify-between items-center gap-4">
        <!-- Title -->
        <div class="relative inline-block">
          <h2 class="relative z-10 text-xl sm:text-3xl md:text-[2.5rem] font-black text-slate-900 dark:text-slate-100 tracking-tight leading-none transition-colors duration-300">
            {{ title }}
          </h2>
          <div class="section-header-bar absolute bottom-0.5 md:bottom-1 left-0 w-full h-2 md:h-3 bg-brand-400/30 dark:bg-brand-500/40 -skew-x-12 rounded-sm z-0"></div>
        </div>
        
        <!-- Action Button -->
        <button
          v-if="showAction"
          @click="$emit('action')"
          class="group flex items-center gap-1.5 text-sm font-bold text-slate-500 dark:text-slate-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors px-3 py-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 flex-shrink-0"
        >
          {{ actionText }}
          <span class="bg-slate-200 dark:bg-slate-700 rounded-full p-0.5 group-hover:bg-brand-500 group-hover:text-white transition-all duration-300">
            <slot name="action-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14m-7-7 7 7-7 7"/></svg>
            </slot>
          </span>
        </button>
      </div>

      <!-- Subtitle -->
      <p v-if="subtitle" class="mt-2 md:mt-3 text-slate-500 dark:text-slate-400 text-xs md:text-base font-medium max-w-xl leading-relaxed tracking-normal transition-colors duration-300">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  name: "SectionHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    actionText: {
      type: String,
      default: "",
    },
    showAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isH5: isH5(),
    };
  },
};
</script>

<style lang="scss" scoped>
// 标题、副标题、间距使用 CSS 变量（仅桌面端）
@media (min-width: 768px) {
  .section-header-wrap {
    > div {
      margin-bottom: var(--section-title-mb, 2.5rem);
    }
    h2 {
      font-size: var(--section-title-size, 2.5rem);
    }
    p {
      font-size: var(--section-subtitle-size, 1rem);
    }
  }
}

// H5: html font-size is 50px, so rem-based tailwind classes are too large
.h5-section-header {
  h2 {
    font-size: 18px !important;
    line-height: 1.3 !important;
  }
  p {
    font-size: 12px !important;
    margin-top: 4px !important;
  }
  > div > div:first-child {
    margin-bottom: 6px !important;
  }
  .section-header-bar {
    height: 4px !important;
    bottom: 1px !important;
  }
  a, .text-sm {
    font-size: 12px !important;
  }
  
  /* Prevent action button from blowing up */
  button {
    padding: 6px 10px !important;
    gap: 4px !important;
    border-radius: 8px !important;
    
    span {
      padding: 2px !important;
      line-height: 1;
      svg {
        width: 14px !important;
        height: 14px !important;
      }
    }
  }
}
</style>
